import { environment } from '@environment/environment';

/**
 * Consent Management lives on a SEPARATE backend service (`consentFormUrl`),
 * not the main `apiUrl`. Trailing slashes on the base are trimmed so the join
 * never produces a double slash (`//v1/...`), which would 404 on the service.
 */
const CONSENT_BASE_URL = environment.consentFormUrl;

/** API endpoints for the Consent Management feature. */
export const CONSENT_API = {
  FORM_BY_ORG: `${CONSENT_BASE_URL}/v1/forms/org`,
  ACCEPT_CONSENT: `${CONSENT_BASE_URL}/v1/public/consents/accept`,
  CONSENT_STATUS: `${CONSENT_BASE_URL}/v1/public/consents/status`
} as const;
